<app-carousel></app-carousel>
<app-productsonhome></app-productsonhome>
<app-latestnews></app-latestnews>
<app-statistics></app-statistics>
<app-relatedlinks></app-relatedlinks>
<app-survay></app-survay>